<script setup lang="ts">
withDefaults(
  defineProps<{
    text?: string
    minHeight?: string
  }>(),
  {
    text: 'Loading...',
    minHeight: undefined,
  },
)
</script>

<template>
  <div
    class="hm-loading"
    :style="minHeight ? { minHeight } : undefined"
    role="status"
    aria-live="polite"
  >
    <div class="hm-loading-spinner" aria-hidden="true"></div>
    <span class="hm-loading-text">{{ text }}</span>
  </div>
</template>

<style scoped>
.hm-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
  gap: 16px;
  box-sizing: border-box;
}

.hm-loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #e0e0e0;
  border-top-color: #00aeef;
  border-radius: 50%;
  animation: hm-loading-spin 0.8s linear infinite;
}

.hm-loading-text {
  font-size: 14px;
  color: #666;
}

@keyframes hm-loading-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
